// extracted by mini-css-extract-plugin
export var aiStarIcon = "_b6-4";
export var closeButton = "_b6-6";
export var dismissButton = "_b6-3";
export var editImageWithAiContainer = "_b6-8";
export var imageUploadWrapper = "_b6-7";
export var misspelledWord = "_b6-5";
export var spellCheckContainer = "_b6-2";
export var spin = "_b6-1";
export var spinning = "_b6-0";